import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';

export const staffingCalendarAccessList = createSelector(getOrganization, (organization): string[] => {
  if (organization === undefined) return [];
  return organization.staffingCalendarAccessList;
});
